 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"page-bind-card":"page-bind-card","page-bind-crypto-address":"page-bind-crypto-address","page-cache-management":"page-cache-management","page-choose":"page-choose","page-game":"page-game","page-game-detail":"page-game-detail","page-game-record":"page-game-record","page-home~page-profile":"page-home~page-profile","page-home":"page-home","page-profile":"page-profile","page-index-info":"page-index-info","page-infomation":"page-infomation","page-language":"page-language","page-list":"page-list","page-loan-center":"page-loan-center","page-loan-records":"page-loan-records","page-loan-repayment":"page-loan-repayment","page-lottery":"page-lottery","page-mine":"page-mine","page-money-log":"page-money-log","page-mymove":"page-mymove","page-notice":"page-notice","page-personalreport":"page-personalreport","page-pinglun-detail":"page-pinglun-detail","page-pl":"page-pl","page-play-video":"page-play-video","page-recharge":"page-recharge","page-recharge-list":"page-recharge-list","page-service-online":"page-service-online","page-service-page":"page-service-page","page-set-login-password":"page-set-login-password","page-set-pay-password":"page-set-pay-password","page-setbank":"page-setbank","page-setname":"page-setname","page-setsex":"page-setsex","page-setting":"page-setting","page-video":"page-video","page-vip-center":"page-vip-center","page-withdraw":"page-withdraw","page-withdraw-record":"page-withdraw-record"}[chunkId]||chunkId) + "." + {"page-bind-card":"3da4d424","page-bind-crypto-address":"5d0dc4d7","page-cache-management":"9d7623de","page-choose":"30d3e64b","page-game":"5d0107d7","page-game-detail":"64ec73c4","page-game-record":"df3450b2","page-home~page-profile":"89696d2a","page-home":"980ad8fd","page-profile":"b573aaf1","page-index-info":"fd788ca8","page-infomation":"4952aff7","page-language":"1d0a28e2","page-list":"d8014d27","page-loan-center":"e08c2e9d","page-loan-records":"d29b27be","page-loan-repayment":"ee983893","page-lottery":"f45473f3","page-mine":"c5dce155","page-money-log":"84baacec","page-mymove":"1ed3baec","page-notice":"08640964","page-personalreport":"29dd0395","page-pinglun-detail":"6301d3c9","page-pl":"d6624a63","page-play-video":"2ec7e072","page-recharge":"2f5ba268","page-recharge-list":"35d32f5d","page-service-online":"5a0a2fae","page-service-page":"7865a3f4","page-set-login-password":"0204f7da","page-set-pay-password":"71556b7f","page-setbank":"6c48c7ea","page-setname":"33235bb7","page-setsex":"a2867aaf","page-setting":"0f16cc54","page-video":"1dcaa0c0","page-vip-center":"dcc76345","page-withdraw":"6130ad36","page-withdraw-record":"3e9ace5a","chunk-2d22d93b":"717564e8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"page-bind-card":1,"page-bind-crypto-address":1,"page-cache-management":1,"page-choose":1,"page-game":1,"page-game-detail":1,"page-game-record":1,"page-home~page-profile":1,"page-home":1,"page-profile":1,"page-index-info":1,"page-infomation":1,"page-language":1,"page-list":1,"page-loan-center":1,"page-loan-records":1,"page-loan-repayment":1,"page-lottery":1,"page-mine":1,"page-money-log":1,"page-mymove":1,"page-notice":1,"page-personalreport":1,"page-pinglun-detail":1,"page-pl":1,"page-play-video":1,"page-recharge":1,"page-recharge-list":1,"page-service-online":1,"page-service-page":1,"page-set-login-password":1,"page-set-pay-password":1,"page-setbank":1,"page-setname":1,"page-setsex":1,"page-setting":1,"page-video":1,"page-vip-center":1,"page-withdraw":1,"page-withdraw-record":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"page-bind-card":"page-bind-card","page-bind-crypto-address":"page-bind-crypto-address","page-cache-management":"page-cache-management","page-choose":"page-choose","page-game":"page-game","page-game-detail":"page-game-detail","page-game-record":"page-game-record","page-home~page-profile":"page-home~page-profile","page-home":"page-home","page-profile":"page-profile","page-index-info":"page-index-info","page-infomation":"page-infomation","page-language":"page-language","page-list":"page-list","page-loan-center":"page-loan-center","page-loan-records":"page-loan-records","page-loan-repayment":"page-loan-repayment","page-lottery":"page-lottery","page-mine":"page-mine","page-money-log":"page-money-log","page-mymove":"page-mymove","page-notice":"page-notice","page-personalreport":"page-personalreport","page-pinglun-detail":"page-pinglun-detail","page-pl":"page-pl","page-play-video":"page-play-video","page-recharge":"page-recharge","page-recharge-list":"page-recharge-list","page-service-online":"page-service-online","page-service-page":"page-service-page","page-set-login-password":"page-set-login-password","page-set-pay-password":"page-set-pay-password","page-setbank":"page-setbank","page-setname":"page-setname","page-setsex":"page-setsex","page-setting":"page-setting","page-video":"page-video","page-vip-center":"page-vip-center","page-withdraw":"page-withdraw","page-withdraw-record":"page-withdraw-record"}[chunkId]||chunkId) + "." + {"page-bind-card":"c3125802","page-bind-crypto-address":"48182c90","page-cache-management":"7872d9f6","page-choose":"83d4f8d4","page-game":"c2d842a8","page-game-detail":"0377aa73","page-game-record":"94ea9e60","page-home~page-profile":"ccddc504","page-home":"203ff229","page-profile":"16048863","page-index-info":"c33c42f0","page-infomation":"ce28375e","page-language":"95abf685","page-list":"482f1065","page-loan-center":"97966c5e","page-loan-records":"f5bb0415","page-loan-repayment":"6b8d46ec","page-lottery":"7dddd6c8","page-mine":"ffaf3b6f","page-money-log":"888164e8","page-mymove":"986034d1","page-notice":"58e1a06d","page-personalreport":"6baa42bb","page-pinglun-detail":"2816f778","page-pl":"e149837e","page-play-video":"c72a67c1","page-recharge":"4880f9b0","page-recharge-list":"ca5ef668","page-service-online":"c1cca5b0","page-service-page":"a01b7b67","page-set-login-password":"e536d44d","page-set-pay-password":"be79e556","page-setbank":"bbb156dc","page-setname":"952a252a","page-setsex":"e452b688","page-setting":"e694726e","page-video":"72afe140","page-vip-center":"30e2346b","page-withdraw":"ef090f7e","page-withdraw-record":"af86dfd3","chunk-2d22d93b":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
